var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 5.5,
    fill: "currentColor",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "check",
    d: "M8.4422 12.0347C8.29834 12.1855 8.05761 12.1854 7.91382 12.0345L6.22737 10.2648C5.99846 10.0246 5.61539 10.024 5.38563 10.2634C5.16992 10.4881 5.1693 10.8428 5.38421 11.0683L7.79463 13.5978C8.00327 13.8167 8.35261 13.8167 8.56126 13.5978L14.6184 7.24159C14.8321 7.01739 14.8321 6.66494 14.6184 6.44073C14.3898 6.2008 14.007 6.20071 13.7782 6.44054L8.4422 12.0347Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkbox.502aa873a7f4a7d41df67942f30e6699.svg";